import React, { useEffect, useRef, useState } from 'react';
import './CommentIndicatorOverlay.css';

const CommentIndicatorOverlay = ({ comments, navigatorMin, navigatorMax, navigatorWidth, navigatorLeft, navigatorTop, isVisible }) => {
  const [hoveredComment, setHoveredComment] = useState(null);
  
  if (!isVisible || !comments || comments.length === 0 || !navigatorWidth || navigatorMin === null || navigatorMax === null) {
    return null;
  }

  const handleCommentClick = (comment) => {
    console.log('Comment clicked:', {
      timestamp: comment.x,
      messageType: comment.messageType,
      messageText: comment.messageText,
      timestampFormatted: new Date(comment.x).toLocaleString()
    });
  };

  const calculatePosition = (commentX) => {
    if (navigatorMin === undefined || navigatorMax === undefined) return null;
    
    // Calculate relative position within the navigator range
    const relativePosition = (commentX - navigatorMin) / (navigatorMax - navigatorMin);
    
    // Convert to pixel position
    const pixelPosition = relativePosition * navigatorWidth;
    
    // Only render if within bounds
    if (relativePosition >= 0 && relativePosition <= 1) {
      return pixelPosition;
    }
    return null;
  };

  return (
    <div 
      className="comment-indicator-overlay"
      style={{
        width: `${navigatorWidth}px`,
        left: `${navigatorLeft}px`,
        top: `${navigatorTop || 0}px`
      }}
    >
      {comments.map((comment, index) => {
        const position = calculatePosition(comment.x);
        if (position === null) return null;
        
        return (
          <div
            key={`${comment.x}-${index}`}
            className="comment-marker"
            style={{ left: `${position}px` }}
            onClick={() => handleCommentClick(comment)}
            onMouseEnter={() => setHoveredComment(comment)}
            onMouseLeave={() => setHoveredComment(null)}
          >
            <svg width="16" height="20" viewBox="0 0 16 20">
              <path
                d="M 2 2 L 14 2 L 14 12 L 10 16 L 8 12 L 2 12 Z"
                fill="#FC1C19"
                stroke="#0000FF"
                strokeWidth="1"
              />
            </svg>
            {hoveredComment === comment && (
              <div className="comment-tooltip">
                {comment.messageText}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CommentIndicatorOverlay;